// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swim-lane-manage-modal-0b9db .swim-lane-manage-labelSelector-7a9d6{background:var(--GRAY_10);border-radius:6px;display:flex;padding:16px 16px 0;width:440px}.swim-lane-manage-modal-0b9db .swim-lane-manage-labelSelector-7a9d6 .swim-lane-manage-labelSelectorValue-afbac{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "swim-lane-manage-modal-0b9db",
	"labelSelector": "swim-lane-manage-labelSelector-7a9d6",
	"labelSelectorValue": "swim-lane-manage-labelSelectorValue-afbac"
};
export default ___CSS_LOADER_EXPORT___;
